import { RESET_STORE } from "../constants/actionTypes";

export const resetStore = () => ({
  type: RESET_STORE
});



// WEBPACK FOOTER //
// ./src/actions/resetStoreActions.js